module.exports = __webpack_public_path__ + "static/img/ad-3.508baa1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ad-3.png
// module id = 12F9
// module chunks = 0